import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  container: {
    borderRadius: 24,
    backgroundColor: '#EBEBEB',
    width: 500,
    padding: 30,
  },

  title: {
    fontSize: 20,
    color: '#1F647A',
    marginBottom: 30,
    fontFamily: 'Raleway_700Bold',
  },

  description: {
    fontSize: 20,
    color: '#1F647A',
    marginBottom: 30,
    fontFamily: 'Raleway_400Regular',
  },

  image: {
    height: 180,
    width: '50%',
    resizeMode: 'contain',
    marginBottom: 30,

    alignSelf: 'center',
  },

  button: {
    width: '100%',
    borderWidth: 2,
    borderColor: '#D9D9D9',
    backgroundColor: '#F0F0F0',
    borderRadius: 8,
    height: 50,
    padding: 12,
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 18,
  },

  textLetter: {
    fontSize: 20,
    color: '#1F647A',
    marginRight: 10,
    fontFamily: 'Montserrat_700Bold',
  },

  textAnswers: {
    fontSize: 18,

    fontFamily: 'Montserrat_400Regular',
  },

  buttonBack: {
    height: 50,
    width: 200,
    borderRadius: 8,
    backgroundColor: '#1F647A',
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
  },

  textBack: {
    fontSize: 20,
    color: '#ffffff',

    fontFamily: 'Raleway_400Regular',
  },
});
